<template>
  <pt-promotion-table class="pt-promotion-table__withData" :labels="labels" :tableData="tableData" @promotionList="promotionList" :totalNumber="totalNumber"
  :selectTab="selectTab" :loading="loading">
      <slot/>
  </pt-promotion-table>
</template>

<script>
import PtPromotionTable from './index'
export default {
  name: 'pt-promotion-table__withData',
  components: {
    'pt-promotion-table': PtPromotionTable
  },
  props: {
    labels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    selectTab: {
      type: String,
      default: ''
    },
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      page: 0,
      loading: false
    }
  },
  watch: {
    queryParams: {
      handler: function (val) {
        this.promotionList(this.page)
      },
      deep: true
    }
  },
  methods: {
    promotionList (page, next) {
      this.page = page
      let data = {
        ...this.queryParams,
        example: {},
        pageableParam: {
          page: page,
          size: this.pageSize,
          sort: 'createdDate,desc'
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getPromotionList', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取促销活动列表失败')
        this.loading = false
      })
    }
  }
}
</script>
